<template>
  <div class="login">
    <LoginForm @showTerms="showTerms = true" />
    <LoginTerms :show.sync="showTerms" />
  </div>
</template>

<script>
import LoginForm from './components/LoginForm.vue'
import LoginTerms from './components/LoginTerms.vue'

export default {
  name: 'Login',

  components: {
    LoginForm,
    LoginTerms,
  },
  data () {
    return {
      showTerms: false,
    }
  },
}
</script>

<style scoped lang="scss">
.login {
  @apply flex justify-center w-full h-full bg-white;
}
</style>
